import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import '../styles/Login.css';

// Landed on from the email reset link. Supabase signs the member in
// via the link; here they choose their new password.
function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async () => {
    setMessage('');
    if (password.length < 8) {
      setMessage('Password needs at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setMessage('Passwords do not match.');
      return;
    }
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setMessage(error.message);
      setBusy(false);
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src="/logo.png" alt="Lighthouse Hunters" className="login-logo" />
        <p className="login-tagline">Choose a new password</p>
        <input
          type="password"
          placeholder="New password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="Repeat new password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
        />
        <button className="btn-primary" onClick={submit} disabled={busy}>
          {busy ? 'Saving...' : 'Save new password'}
        </button>
        {message && <p className="login-message">{message}</p>}
      </div>
    </div>
  );
}

export default ResetPasswordPage;
